import React, { Component } from 'react';
import './style.css';
import { connect } from 'react-redux';
import { updateEmail, clearError, clearSuccess } from './ducks/actions';
import { Row, Col, Alert, Modal, Button, ControlLabel } from 'react-bootstrap';
export class UpdateEmail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      email: '',
      secret: ''
    };
    this.toggleModal = this.toggleModal.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.updateEmail = this.updateEmail.bind(this);
    this.handleErrorDismiss = this.handleErrorDismiss.bind(this);
    this.handleSuccessDismiss = this.handleSuccessDismiss.bind(this);
  }

  updateEmail() {
    this.props.actions.updateEmail(this.state.email, this.state.secret);
  }
  toggleModal(event) {
    if (!this.state.showModal) {
      this.props.actions.clearError();
      this.props.actions.clearSuccess();
    }
    this.setState({
      showModal: !this.state.showModal
    });
  }
  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }
  handleErrorDismiss() {
    this.props.actions.clearError();
  }
  handleSuccessDismiss() {
    this.props.actions.clearSuccess();
  }
  render() {
    var errorMessage;
    if (this.props.error) {
      errorMessage = (
        <Row>
          <Col xs={12}>
            <Alert bsStyle="danger" onDismiss={this.handleErrorDismiss}>
              {this.props.error}
            </Alert>
          </Col>
        </Row>
      );
    }

    var successMessage;
    if (this.props.success) {
      successMessage = (
        <Row>
          <Col xs={12}>
            <Alert bsStyle="success" onDismiss={this.handleSuccessDismiss}>
              {this.props.success}
            </Alert>
          </Col>
        </Row>
      );
    }
    return (
      <span>
        <a onClick={this.toggleModal}>Change Email Address</a>
        <Modal show={this.state.showModal} onHide={this.toggleModal}>
          <Modal.Header closeButton>
            <Modal.Title>Change Email Address</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col xs={12} className="form-group">
                {errorMessage}
                {successMessage}
                <ControlLabel>New Email Address</ControlLabel>
                <div className="input-group">
                  <div className="input-group-addon">
                    <i className="fa fa-fw fa-user-circle" />
                  </div>
                  <input
                    className="form-control"
                    placeholder="Enter Email"
                    type="text"
                    name="email"
                    value={this.state.email}
                    onChange={this.handleChange}
                  />
                </div>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col xs={12} className="form-group">
                <p>
                  Please re-enter your current password below for user
                  verification.
                </p>
                <ControlLabel>Current Password</ControlLabel>
                <div className="input-group">
                  <div className="input-group-addon">
                    <i className="fa fa-fw fa-lock" />
                  </div>
                  <input
                    className="form-control"
                    placeholder="Enter Current Password"
                    type="password"
                    name="secret"
                    value={this.state.secret}
                    onChange={this.handleChange}
                  />
                </div>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.toggleModal}>Cancel</Button>
            <Button
              bsStyle="primary"
              onClick={this.updateEmail}
              disabled={this.props.success ? true : false}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      </span>
    );
  }
}

const mapStateToProps = state => {
  return {
    error: state.updateEmailReducer.error,
    success: state.updateEmailReducer.success
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      updateEmail: (email, secret) => {
        dispatch(updateEmail(email, secret));
      },
      clearError: () => {
        dispatch(clearError());
      },
      clearSuccess: () => {
        dispatch(clearSuccess());
      }
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateEmail);



// WEBPACK FOOTER //
// ./src/components/account/UpdateEmail/index.js